/**
 * Permission Utility Functions
 */

/**
 * Get user permission for a specific permission name
 * @param {Array} permissionList - List of user permissions
 * @param {string} permissionName - Name of the permission to check
 * @returns {Object} - Object with read and write flags
 */
export const getPermission = (permissionList, permissionName) => {
  if (!permissionList || !Array.isArray(permissionList)) {
    return { read: false, write: false };
  }

  const permissionData = permissionList.find(
    (element) => element.Permission?.permission_name === permissionName
  );

  if (permissionData) {
    return {
      read: Boolean(permissionData.read),
      write: Boolean(permissionData.write),
    };
  }

  return { read: false, write: false };
};

/**
 * Check if user has granted permission (read or write)
 * @param {string} permissionName - Name of the permission to check
 * @param {Array} permissionList - List of user permissions
 * @returns {boolean} - True if user has read or write permission
 */
export const isGranted = (permissionName, permissionList) => {
  if (!permissionList || !Array.isArray(permissionList)) {
    return true; // Default to true if no permission list (backward compatibility)
  }

  const permissionData = permissionList.find(
    (element) => element.Permission?.permission_name === permissionName
  );

  if (permissionData) {
    return Boolean(permissionData.read || permissionData.write);
  }

  return true; // Default to true if permission not found (backward compatibility)
};


